import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'input-switch-new',
	templateUrl: './input-switch-new.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class InputSwitchNewComponent {
	
	@Input() label: any | undefined;
	@Input() isDisabled: any | undefined;
	@Input() toggleFn: () => void;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	get invertedIsDisabled(): boolean {
	  return !this.vm.isDisabled;
	}

	set invertedIsDisabled(value: boolean) {
	  this.vm.isDisabled = !value;
	}
	
	onClick() {
		this.toggleFn();
	}
}